let url = '/v1/admin/unaccepted-request';

export const REQUEST_ENDPOINT = {
  getRequestList: {
    url,
    method: 'GET',
  },
};

